/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageModule')
.controller('ViewPanelController', ['BulbPageService', ViewPanelController]);

/**
* AngularJS controller for the view panel.
*/
function ViewPanelController(BulbPageService) {
  this.page = BulbPageService.page;
}



